import { useState, useContext } from "react";
import { Alert, Button, TextField } from "@mui/material";
import AppContext from "../../contexts/AppContext";
import { useParams } from "react-router-dom";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";

export default function AttendanceDKPUpdate({ setSessionData }) {
  const { API } = useContext(AppContext);
  const [dkpAmount, setDkpAmount] = useState("10");
  const { id } = useParams();
  const { pending, error, run } = useAsyncAction();
  const valid = /^-?\d+$/.test(dkpAmount);
  return (
    <>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField disabled={pending} value={dkpAmount} onChange={(e) => setDkpAmount(e.target.value)}
        variant="outlined" label="DKP Award Amount" type="number" error={!valid}
        helperText={!valid ? "Enter a whole number." : ""} />
      <Button disabled={pending || !valid} variant="outlined" onClick={() => run(async () => {
        const response = await apiFetch(`${API}/session/${id}`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ dkpAmount, action: "UPDATE_AWARD_DKP" }),
        });
        setSessionData(await response.json());
      })}>{pending ? "Updating..." : "Update DKP Award Amount"}</Button>
    </>
  );
}
